document.querySelectorAll('.searchPanel').forEach(panel => {
  const overlay = panel.previousElementSibling; // assumes overlay is before panel
  const closeBtn = panel.querySelector('.closeSearch');
  const searchInput = panel.querySelector('.cus-search');
  const resultsContainer = panel.querySelector('.search-results');
  const body = document.body;

  // OPEN buttons (global, but target THIS panel)
  document.querySelectorAll('.openSearch').forEach(btn => {
    btn.addEventListener('click', () => {
      panel.classList.add('active');
      overlay.classList.add('active');
      body.style.overflow = "hidden";
    });
  });

  // CLOSE
  closeBtn.addEventListener('click', () => {
    panel.classList.remove('active');
    overlay.classList.remove('active');
    body.style.overflow = "auto";
  });

  overlay.addEventListener('click', () => {
    panel.classList.remove('active');
    overlay.classList.remove('active');
    body.style.overflow = "auto";
  });

  // SEARCH INPUT (scoped)
  searchInput.addEventListener('input', function () {
    const query = this.value.trim();

    if (query.length > 0) {
      fetch(`/search/suggest.json?q=${query}&resources[type]=product`)
        .then(res => res.json())
        .then(data => {
          displayResults(data.resources.results.products);
        });
    } else {
      resultsContainer.innerHTML = '';
    }
  });

    function displayResults(products) {
  resultsContainer.innerHTML = '';
  const searchTerm = searchInput.value.trim();

  if (products.length === 0) {
    resultsContainer.innerHTML = `
      <a href="https://eyemax.pk/search?q=${searchTerm}" class="unavailable search_for">
        <span>Search for "${searchTerm}"</span>
        <span>
          <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
          </svg>
        </span>
      </a>`;
    return;
  }

  resultsContainer.innerHTML = `<h2>PRODUCTS</h2>`;

  const limitedProducts = products.slice(0, 3);

  limitedProducts.forEach(product => {

    // ── Badge Logic ──────────────────────────────────────────────
    let badgeHTML = '';

    if (!product.available) {
      badgeHTML = `<span class="badge badge--bottom-left color-sold-out">Sold Out</span>`;

    } else if (product.compare_at_price_max && product.compare_at_price_max > product.price) {
      const discount = Math.round(
        ((product.compare_at_price_max - product.price) / product.compare_at_price_max) * 100
      );
      badgeHTML = `<span class="badge badge--bottom-left color-sale">Sale</span>`;
    }
    // ─────────────────────────────────────────────────────────────

    const productHTML = `
      <div class="product-item">
        <a href='${product.url}'>
          <div class="img-wrapper">
            <img src="${product.image}" alt="${product.title}" width="100">
          </div>
          <div class="content_item">
            <div class="wrapper-title-price">
              ${badgeHTML} 
              <h3 class="h4">${product.title}</h3>
              <p>Rs.${product.price}</p>
            </div>
            <p>View Detail</p>
          </div>
        </a>
      </div>
    `;

    resultsContainer.innerHTML += productHTML;
  });

  resultsContainer.innerHTML += `
    <a href="https://eyemax.pk/search?q=${searchTerm}" class="unavailable search_for search_for_large">
      <span>Search for "${searchTerm}"</span>
      <span>
        <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
        </svg>
      </span>
    </a>`;
}

});  